import { ReactNode } from "react";

import styles from "./HomeLayout.module.css";
import Aside from "./Aside";

const HomeLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <Aside />
        {children}
      </div>
    </div>
  );
};
export default HomeLayout;
